import { REPORT2025_DETAIL_UPDATE, REPORT2025_FORM_UPDATE, REPORT2025_SOURCES_UPDATE } from '../mutationTypes';

const state = {
  sources: {},
  detail: {
    id: '',
    nickName: '',
    annualTitle: '',
    userRegisterTime: '', //注册时间
    userRegisterToNowDays: 0, //练习时长
    firstBindTime: '', //首次绑定车辆的时间
    firstBindVehicleTypeName: '', //首次绑定车型名称
    firstRideAddress: '', //第一次骑行的地点
    firstRideTime: '', //第一次骑行的时间
    lastRideAddress: '', //最后一次骑行的地点
    lastRideTime: '', //最后一次骑行的时间
    totalRideDistance: 0, //总骑行里程(公里)
    totalRideNum: 0, //横穿中国次数
    totalRideDistanceRankRate: 0, //百分之多少的用户
    totalRideDuration: 0, //总骑行时长
    totalGameNum: 0, //从青铜打上王者次数
    throughCityCount: 0, //途经城市的数量
    totalRideCount: 0, //轨迹数
    throughCityNameList: [], //途径的城市名称
    singleMaxDistanceMileage: 0, //单次最长骑行里程(公里)
    singleMaxDistanceStartCityName: '', //单次最长骑行里程开始地点
    singleMaxDistanceEndCityName: '', //单次最长骑行里程结束地点
    dayMaxDistanceDuration: 0, //单日最长骑行时长(分钟)
    dayMaxRideCount: 0, //单日骑行次数最多
    dayMaxRideTime: '', //单日骑行次数最多时间
    dayMaxDistanceMileage: 0, //单日最长骑行里程(公里)
    mostActiveMonth: '', //最活跃月份
    mostActiveMonthCount: 0, //最活跃月份骑行次数
    totalBendingCount: 0, //压弯总次数
    totalAccelerationCount: 0, //急加速总次数
    avgAccelerateCount: 0, //急加速人均次数
    superSpeed: 0, //最快速度
    firstPostTime: '', //第1次发贴时间
    totalParticipateTopicCount: 0, //参与话题总数
    integralTotal: 0, //积分总额
    warGodAddress: '', //战神地址
    warGodTitle: '', //战神称号
    mustVisit: [], //此生必驾(集合)
    consumptionAmount: 0, //消费金额(元)
    consumptionRanking: 0, //消费排名
    activeLevel: 0, //社区活跃度
    onePeriod: 0, //骑行时段0时-3时
    twoPeriod: 0, //骑行时段4时-6时
    threePeriod: 0, //骑行时段7时-9时
    fourPeriod: 0, //骑行时段10时-12时
    fivePeriod: 0, //骑行时段13时-15时
    sixPeriod: 0, //骑行时段16时-18时
    sevenPeriod: 0, //骑行时段19时-21时
    eightPeriod: 0, //骑行时段22时-23时
    periodContent: '', //骑行时段文案
    medalist: [], //徽章
    avgActiveLevel: 0, //人均活跃度
    avgLeanCnt: 0, //人均压弯次数
    avgMaxSpeed: 0, //人均极速
    avgTotalMile: 0, //人均总里程
    avgTotalTime: 0, //人均总时长
    maxActiveLevel: 0, //最大活跃度
    maxLeanCnt: 0, //最大压弯次数
    maxMaxSpeed: 0, //最大极速
    maxTotalMile: 0, //最大总里程
    maxTotalTime: 0, //最大总时长
    contentRatio: 1,
    isLowerDevice: false,
    version: 1,
  },
  form: {
    isAgreement: false,
    submitClick: false,
  },
};
const mutations = {
  [REPORT2025_SOURCES_UPDATE](states, sources) {
    Object.keys(sources).forEach((key) => {
      states.sources[key] = sources[key];
    });
  },
  [REPORT2025_DETAIL_UPDATE](states, detail) {
    console.log('--报告数据--', detail);
    states.detail = { ...states.detail, ...detail };
  },
  [REPORT2025_FORM_UPDATE](states, value) {
    states.form = { ...JSON.parse(JSON.stringify(states.form)), ...value };
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
